import { JSONApiFilter } from '@letsdial/api/src'
import { defineStore } from 'pinia'

export interface ListState {
  query?: string
  currentPage?: number
  filters?: JSONApiFilter
  custom?: Record<string, any>
}

export const useFilterStore = defineStore('filter', {
  state: () => ({
    listStates: {} as Record<string, ListState>,
    initialStates: {} as Record<string, ListState>,
  }),
  actions: {
    getState(key: string): ListState | undefined {
      return this.listStates[key]
    },
    setState(key: string, state: Partial<ListState>) {
      if (!this.listStates[key]) {
        this.listStates[key] = {}
      }
      this.listStates[key] = {
        ...this.listStates[key],
        ...state,
      }
    },
    getInitialState(key: string): ListState | undefined {
      return this.initialStates[key]
    },
    setInitialState(key: string, state: ListState) {
      if (!this.initialStates[key]) {
        this.initialStates[key] = JSON.parse(JSON.stringify(state))
      }
    },
    resetToInitial(key: string): ListState {
      const initial = this.initialStates[key] ?? {
        query: undefined,
        currentPage: 1,
        filters: {},
      }
      const restored = JSON.parse(JSON.stringify(initial))
      this.listStates[key] = restored
      return restored
    },
    setCustomState(key: string, refName: string, value: any) {
      if (!this.listStates[key]) {
        this.listStates[key] = {}
      }
      if (!this.listStates[key].custom) {
        this.listStates[key].custom = {}
      }
      this.listStates[key].custom![refName] = value
    },
    getCustomState(key: string, refName: string, defaultValue: any = null) {
      return this.listStates[key]?.custom?.[refName] ?? defaultValue
    },
    clearState(key: string) {
      delete this.listStates[key]
      delete this.initialStates[key]
    },
    clearAll() {
      this.listStates = {}
      this.initialStates = {}
    },
  },
})
